import React from 'react';
import { Box, Tab, Tabs, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Tab bar for open workspace instances.
 * Each tab represents an independent workspace with its own state.
 */
const WorkspaceTabs = ({ tabs, activeTabId, onTabChange, onTabClose, colors }) => {
  if (!tabs || tabs.length === 0) return null;

  return (
    <Box
      sx={{
        borderBottom: `1px solid ${colors.border}`,
        bgcolor: colors.surface,
        display: 'flex',
        alignItems: 'center',
        minHeight: 38,
      }}
    >
      <Tabs
        value={activeTabId || false}
        onChange={(_, newValue) => onTabChange(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: 38,
          flexGrow: 1,
          '& .MuiTabs-indicator': { bgcolor: '#22c55e' },
          '& .MuiTab-root': {
            minHeight: 38,
            textTransform: 'none',
            color: colors.textSecondary,
            fontSize: '0.8rem',
            py: 0,
            '&.Mui-selected': { color: '#22c55e' },
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.tabId}
            value={tab.tabId}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <span>{tab.label}</span>
                {/* Pinned tabs (e.g. the synthetic "Atom Response" tab) have
                    no close affordance -- see project_atom_response_workspace_tab
                    memory: results should persist for the whole session. */}
                {!tab.pinned && (
                  <Tooltip title="Close">
                    {/* A span, not a <button>: the Tab is already a button, and a button
                        inside a button is invalid HTML (React warns on every render) */}
                    <IconButton
                      component="span"
                      role="button"
                      aria-label={`Close ${tab.label}`}
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        onTabClose(tab.tabId);
                      }}
                      sx={{
                        p: 0.25,
                        ml: 0.5,
                        color: colors.textMuted,
                        '&:hover': {
                          color: '#ef4444',
                          bgcolor: 'rgba(239, 68, 68, 0.1)',
                        },
                      }}
                    >
                      <CloseIcon sx={{ fontSize: 14 }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            }
            sx={{ minWidth: 120, maxWidth: 200 }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default WorkspaceTabs;
